var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.765 3.10897L14.355 4.32502C14.7651 4.63862 15.25 4.83949 15.7617 4.9077L17.746 5.17218C18.3094 5.24728 18.7527 5.69055 18.8278 6.25399L19.0923 8.23824C19.1605 8.74993 19.3614 9.23488 19.675 9.64494L20.891 11.235C21.2363 11.6865 21.2363 12.3134 20.891 12.7649L19.675 14.355C19.3614 14.7651 19.1605 15.25 19.0923 15.7617L18.8278 17.746C18.7527 18.3094 18.3094 18.7527 17.746 18.8278L15.7617 19.0923C15.2501 19.1605 14.7651 19.3613 14.355 19.6749L12.765 20.891C12.3134 21.2363 11.6866 21.2363 11.235 20.891L9.64495 19.6749C9.2349 19.3613 8.74995 19.1605 8.23825 19.0923L6.25401 18.8278C5.69056 18.7527 5.2473 18.3094 5.17219 17.746L4.90771 15.7617C4.83951 15.25 4.63863 14.7651 4.32504 14.355L3.10898 12.7649C2.76367 12.3134 2.76367 11.6865 3.10898 11.235L4.32504 9.64494C4.63863 9.23488 4.83951 8.74993 4.90771 8.23824L5.17219 6.25399C5.2473 5.69055 5.69056 5.24728 6.25401 5.17218L8.23825 4.9077C8.74995 4.83949 9.2349 4.63862 9.64495 4.32502L11.235 3.10897C11.6866 2.76366 12.3134 2.76366 12.765 3.10897Z",
    stroke: "#BCBCBC",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1092 9.89076L9.89075 14.1092",
    stroke: "#BCBCBC",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.89079,
    cy: 9.89076,
    r: 1.05461,
    fill: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.1092,
    cy: 14.1092,
    r: 1.05461,
    fill: "#BCBCBC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.b7bc244a0371cd5db82ae612e367cd69.svg";
export { ForwardRef as ReactComponent };